import React from "react";
import propTypes from "prop-types";
import { Row, Col, Form, FormGroup, Input, Label, Button } from "reactstrap";

const FilterForm = (props) => (
  <Form className="form-filter" onSubmit={props.onSubmit}>
    <Row>
      <Col xs={12} md={6}>
        <div className="d-flex flex-column">
          <div className="d-flex px-3">
            <FormGroup className="d-flex flex-column align-items-start">
              <Label className="mb-2" style={{ fontWeight: 700 }}>
                Status
              </Label>
              <div className="d-flex ml-2 mr-2">
                <FormGroup check className="mr-2">
                  <Label check>
                    <Input
                      type="radio"
                      name="active"
                      value=""
                      checked={props.active === ""}
                      onChange={props.onCheckedChange}
                    />{" "}
                    All
                  </Label>
                </FormGroup>
                <FormGroup check className="mr-2">
                  <Label check>
                    <Input
                      type="radio"
                      name="active"
                      value="1"
                      checked={props.active === "1"}
                      onChange={props.onCheckedChange}
                    />{" "}
                    Active
                  </Label>
                </FormGroup>
                <FormGroup check className="mr-2">
                  <Label check>
                    <Input
                      type="radio"
                      name="active"
                      value="0"
                      checked={props.active === "0"}
                      onChange={props.onCheckedChange}
                    />{" "}
                    Inactive
                  </Label>
                </FormGroup>
              </div>
            </FormGroup>
          </div>
          <FormGroup className="align-self-start px-3 mb-2">
            <Button color="primary">Apply Filter</Button>
          </FormGroup>
        </div>
      </Col>
    </Row>
  </Form>
);

export default FilterForm;

FilterForm.defaultProps = {
  active: "",
};

FilterForm.propTypes = {
  onCheckedChange: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired,
  active: propTypes.string,
};
